/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type d\'environnement :\n- URBAN : Urbain\n- RURAL : Rural\n
 */
export const propertyTypeEnvironmentSchema = z.enum(["URBAN", "RURAL"]).default("URBAN").describe("Type d'environnement :\n- URBAN : Urbain\n- RURAL : Rural\n")